import { useId } from 'react';
import type { IconProps } from '@src/components/icons/IconProps';

/** Russian tricolor. Colours are the flag, not theme tokens. */
export function RuFlagIcon({ className }: IconProps) {
  const clipId = useId();

  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <clipPath id={clipId}>
          <rect x="2" y="6" width="20" height="12" rx="1.5" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <rect x="2" y="6" width="20" height="4" fill="#fff" />
        <rect x="2" y="10" width="20" height="4" fill="#0039a6" />
        <rect x="2" y="14" width="20" height="4" fill="#d52b1e" />
      </g>
    </svg>
  );
}
